module.exports = __webpack_public_path__ + "static/media/supportedCropsImage.a70c7e67.webp";